import React from "react";
import LeavingFDICDialog from "./LeavingFDICDialog";
import { Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Map, TileLayer, Marker } from "react-leaflet";
import clsx from "clsx";

interface Props {
  lat: number;
  lng: number;
  zoom: number;
  height?: number | string;
  width?: number | string;
}

const useStyles = makeStyles({
  map: {
    "& img.leaflet-marker-icon": {
      cursor: "grab",
    },
  },
  attribution: {
    "&.leaflet-control-attribution ": {
      "position": "absolute",
      "bottom": 0,
      "right": 0,
      "display": "inline-flex",
      "padding": "0px 5px",

      "& *": {
        textTransform: "none",
        fontSize: 11,
      },
      "& a": {
        padding: "0px 3px",
      },
    },
  },
});

export default function LocationMap({ lat, lng, zoom, height, width }: Props) {
  const classes = useStyles();
  const position = { lat, lng };
  return (
    <Map
      style={{ height, width }}
      center={position}
      zoom={zoom}
      className={classes.map}
      attributionControl={false}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Marker position={position} />
      <Typography
        component="div"
        className={clsx(
          "leaflet-control-attribution leaflet-control",
          classes.attribution,
        )}
      >
        <LeavingFDICDialog
          webAddress="https://leafletjs.com/"
          label="Leaflet"
          noHover
        />
        <Typography component="div" style={{ fontSize: 13 }}>
          | ©
        </Typography>
        <LeavingFDICDialog
          webAddress="https://www.openstreetmap.org/copyright"
          label="OpenStreetMap"
          noHover
        />
        <Typography component="div">contributors</Typography>
      </Typography>
    </Map>
  );
}
